import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import Navbar from './components/Navbar';
import Footer from './components/Footer';

import HomePage            from './pages/HomePage';
import AboutPage           from './pages/AboutPage';
import CommitteesPage      from './pages/CommitteesPage';
import CommitteeDetailPage from './pages/CommitteeDetailPage';
import TeamPage            from './pages/TeamPage';
import SponsorsPage        from './pages/SponsorsPage';
import ContactPage         from './pages/ContactPage';
import ApplicationPage     from './pages/ApplicationPage';
import NotFoundPage        from './pages/NotFoundPage';

import './styles/global.css';

function ScrollToTop() {
  const { pathname } = useLocation();
  React.useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [pathname]);
  return null;
}

function AnimatedRoutes() {
  const location = useLocation();
  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/"                    element={<HomePage />} />
        <Route path="/hakkimizda"          element={<AboutPage />} />
        <Route path="/komiteler"           element={<CommitteesPage />} />
        <Route path="/komiteler/:slug"     element={<CommitteeDetailPage />} />
        <Route path="/ekibimiz"            element={<TeamPage />} />
        <Route path="/sponsorlar"          element={<SponsorsPage />} />
        <Route path="/iletisim"            element={<ContactPage />} />
        <Route path="/basvuru"             element={<ApplicationPage />} />
        <Route path="*"                    element={<NotFoundPage />} />
      </Routes>
    </AnimatePresence>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Navbar />
      <main>
        <AnimatedRoutes />
      </main>
      <Footer />
    </BrowserRouter>
  );
}
